/**
 * Le quattro finestre temporali del mock v11: il mese in corso e i tre
 * precedenti.
 *
 * Vivono qui e non nella vista che le ha introdotte perché il selettore è lo
 * stesso su Monitoraggio e Incentivi — e due copie dello stesso calendario si
 * sarebbero disallineate al primo cambio di etichetta.
 */

const MONTH_NAMES = [
	'gennaio',
	'febbraio',
	'marzo',
	'aprile',
	'maggio',
	'giugno',
	'luglio',
	'agosto',
	'settembre',
	'ottobre',
	'novembre',
	'dicembre',
];

/**
 * Valore della scheda «mese in corso». Non è un `YYYY-MM` perché il mese in
 * corso finisce oggi, non l'ultimo del mese: chiederlo per intero al server
 * significherebbe una finestra che sconfina nel futuro. Fuori dalle viste
 * questo periodo si chiama `null`.
 */
export const PERIOD_CURRENT = 'corrente';

function capitalize(s: string): string {
	return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Nome italiano del mese, indice 0-11. */
export function monthName(index: number): string {
	return MONTH_NAMES[index] ?? '';
}

/** Le quattro schede: il mese in corso e i tre precedenti. */
export function buildPeriodTabs(today: Date): { value: string; label: string }[] {
	const tabs = [{ value: PERIOD_CURRENT, label: 'Mese in corso' }];
	for (let i = 1; i <= 3; i += 1) {
		const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
		// L'anno compare solo quando il mese non è di quest'anno: a gennaio
		// «Dicembre» da solo non dice quale dicembre.
		const year = d.getFullYear() === today.getFullYear() ? '' : ` ${d.getFullYear()}`;
		tabs.push({
			value: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`,
			label: `${capitalize(monthName(d.getMonth()))}${year}`,
		});
	}
	return tabs;
}

/** Anno e mese (1-12) guardati: il periodo scelto, o il mese in corso. */
export function periodMonth(period: string | null | undefined): { year: number; month: number } {
	if (period && /^\d{4}-\d{2}$/.test(period)) {
		const [year, month] = period.split('-').map(Number) as [number, number];
		return { year, month };
	}
	const now = new Date();
	return { year: now.getFullYear(), month: now.getMonth() + 1 };
}
